// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1mPhm4h7B2E9f5ZbVywN5D {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: .5em;\n    width: auto;\n}", "",{"version":3,"sources":["webpack://./src/components/reusable/maintenance/styles/MaintenanceLevel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;AACf","sourcesContent":[".container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: .5em;\n    width: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_1mPhm4h7B2E9f5ZbVywN5D"
};
export default ___CSS_LOADER_EXPORT___;
